export default "__VITE_ASSET__bjmMVzkh__"